import PointTag from "../../../../src/entities/PointTag";
import { Coord } from "../../../../src/types/Interface";
import degreeToRadian from "../../../../src/utils/degreeToRadian";
import calculateAngles from "../../../../src/utils/calculateAngles";
import generateAngle from "../../../../src/utils/generateAngle";


export default class PointTagManager {
  private center = new PointTag("O");
  private side1 = new PointTag("A")
  private side2 = new PointTag("B")
  private circum = new PointTag("C")

  constructor() {
  }

  setVisible = (visible: boolean) => [this.center, this.side1, this.side2, this.circum].forEach(pName => pName.visible = visible);

  updateCenterName([cPoint, s1Point, s2Point]: Coord[], cClockwise: boolean) {
    const cAngles = calculateAngles(cPoint, s1Point, s2Point);
    const degree = generateAngle(cAngles, cClockwise);
    const initialAngle = cClockwise ? cAngles.endRadian : cAngles.startRadian;
    const nameAngle = initialAngle + degreeToRadian(degree / 2) + Math.PI;
    const coord = {
      x: Math.cos(nameAngle) * 30 + cPoint.x,
      y: Math.sin(nameAngle) * 30 + cPoint.y
    }
    this.center.updateCoord(coord);
  }
  updateCoord(coords: Coord[]) {
    this.side1.updateCoord(coords[0]);
    this.side2.updateCoord(coords[1]);
    this.circum.updateCoord(coords[2]);
  }
}